import { createI18n } from 'vue-i18n'
import en from './en.json'
import vi from './vi.json'

export const supportedLocales = ['en', 'vi'] as const
export type SupportedLocale = (typeof supportedLocales)[number]

const STORAGE_KEY = 'locale'

function getBrowserLocale(): SupportedLocale {
  const browser = navigator.language || (navigator as any).userLanguage
  const code = browser.split('-')[0].toLowerCase()
  if (supportedLocales.includes(code as SupportedLocale)) return code as SupportedLocale
  return 'en'
}

function getSavedLocale(): SupportedLocale | null {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved && supportedLocales.includes(saved as SupportedLocale)) return saved as SupportedLocale
  } catch (_) {}
  return null
}

export function getInitialLocale(): SupportedLocale {
  return getSavedLocale() ?? getBrowserLocale()
}

export function setLocaleStorage(locale: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch (_) {}
}

const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  // Nested locale JSON (e.g. admin.events.*) does not resolve reliably with flatJson: true;
  // intlify may report missing keys and show raw paths in the UI.
  flatJson: false,
  messages: {
    en,
    vi,
  },
})

export default i18n
